export default "__VITE_ASSET__BY7mIZ7___"